import React from 'react'
import {
  KeyboardAvoidingView,
  KeyboardAvoidingViewProps,
  ScrollView,
  StatusBar,
  StyleProp,
  ViewStyle,
} from 'react-native'

import { useHeaderHeight } from '@react-navigation/elements'
import { Stack } from '@zet/design-system/layout'

interface KeyBoardWrapperType extends KeyboardAvoidingViewProps {
  BottomSheet?: React.ReactNode
  wrapperStyle?: string
  scrollViewContentContainerstyle?: StyleProp<ViewStyle>
}
const KeyBoardWrapper = ({
  BottomSheet,
  children,
  wrapperStyle,
  scrollViewContentContainerstyle,
  ...props
}: KeyBoardWrapperType) => {
  const headerHeight = useHeaderHeight()
  return (
    <KeyboardAvoidingView
      style={{
        flex: 1,
        flexGrow: 1,
        justifyContent: 'space-between',
        backgroundColor: '#FFF',
      }}
      // behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      keyboardVerticalOffset={
        headerHeight === 0 ? StatusBar.currentHeight : headerHeight
      }
      enabled
      {...props}
    >
      <ScrollView
        showsVerticalScrollIndicator={false}
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={scrollViewContentContainerstyle}
      >
        {children}
      </ScrollView>
      <Stack className={wrapperStyle}>{BottomSheet}</Stack>
    </KeyboardAvoidingView>
  )
}
export default KeyBoardWrapper
